export { default } from './render-bank-logo';
